import { getAffairStage } from './affairModel';

const currencyFormatter = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});

const dateFormatter = new Intl.DateTimeFormat('fr-FR');

export const formatAffairAmount = (value) => currencyFormatter.format(Number(value || 0));
export const formatAffairStage = (stage) => getAffairStage(stage).label;

export const formatAffairDate = (value, fallback = '—') => {
  if (!value) return fallback;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? fallback : dateFormatter.format(date);
};

export const getAffairPartnerName = (affair) => {
  const partner = affair?.partner || affair?.Partner || affair?.client || affair?.Client;
  return partner?.socialReason || partner?.social_reason || partner?.name || '—';
};

export const getAffairDisplayName = (affair) => [affair?.code, affair?.name].filter(Boolean).join(' · ') || 'Affaire';
export const getAffairOwnerName = (affair) => {
  const owner = affair?.Owner || affair?.owner;
  const fullName = [owner?.firstName || owner?.first_name, owner?.lastName || owner?.last_name]
    .filter(Boolean).join(' ').trim();
  const ownerId = affair?.ownerUserId || affair?.owner_user_id || owner?.id;
  return fullName || owner?.displayName || owner?.label || owner?.name || owner?.email
    || affair?.ownerName || affair?.owner_name
    || (ownerId ? `Utilisateur #${ownerId}` : 'Non affecté');
};
